import { render } from "./GreetingHeader.vue?vue&type=template&id=12733a49&scoped=true"
import script from "./GreetingHeader.vue?vue&type=script&lang=js"
export * from "./GreetingHeader.vue?vue&type=script&lang=js"

import "./GreetingHeader.vue?vue&type=style&index=0&id=12733a49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12733a49"]])

export default __exports__